import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import EcoIcon, { EcoIconName } from "../../../components/eco-icon/EcoIcon";
import EcoPageHeader from "../../../components/eco-page-header/EcoPageHeader";
import { useGoBack } from "../../../hooks/useGoBack";

import type { RootState } from "../../../store/store";
import { LOGINPAGE } from "../../auth/routes";
import { HOMEPAGE } from "../../home/routes";
import { FEFOPAGE } from "../../fefo/routes";
import "../../dp/pages/DpEco.css";

type ModuleCard = {
  key: string;
  title: string;
  description: string;
  icon: EcoIconName;
  onClick: () => void;
};

const ProcessosZePage: React.FC = () => {
  const navigate = useNavigate();
  const goBack = useGoBack(HOMEPAGE());
  const token = useSelector((state: RootState) => state.auth.accessToken);

  useEffect(() => {
    if (!token) {
      toast.error("Você precisa estar logado.");
      navigate(LOGINPAGE(), { replace: true });
    }
  }, [token, navigate]);

  const modules = useMemo<ModuleCard[]>(
    () => [
      {
        key: "fefo-shelf",
        title: "Fefo/Shelf",
        description: "Planilha de contagem de bebidas das lojas, com os indicadores de FEFO e de prateleira por temperatura.",
        icon: "thermometer",
        onClick: () => navigate(FEFOPAGE()),
      },
    ],
    [navigate],
  );

  if (!token) return null;

  return (
    <div className="dpePage">
      <main className="dpePage__main">
        <EcoPageHeader
          crumbs={[{ label: "Início", onClick: () => navigate(HOMEPAGE()) }, { label: "Processos Zé" }]}
          title="Processos Zé"
          subtitle="Monitorar e administrar os processos das lojas."
          onBack={goBack}
          backLabel="Voltar ao início"
        />

        <section className="dpeSection" aria-labelledby="proc-modulos">
          <h2 id="proc-modulos" className="dpeSection__title">Módulos</h2>
          <div className="dpeModules">
            {modules.map((m) => (
              <button key={m.key} type="button" className="dpeModule" onClick={m.onClick}>
                <span className="dpeModule__icon">
                  <EcoIcon name={m.icon} size={20} strokeWidth={1.8} />
                </span>
                <span className="dpeModule__text">
                  <span className="dpeModule__title">{m.title}</span>
                  <span className="dpeModule__desc">{m.description}</span>
                </span>
                <EcoIcon name="chevronRight" className="dpeModule__chevron" />
              </button>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default ProcessosZePage;
